import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { getBalloonVehicleInfoThunk } from 'actions/vehicleActions';
import { IDealSourceData } from 'modules/core/types/dealSource';

import { extractDealSourceParams } from '../utils/dealSourceData.utils';

export const useRequestBalloonVehicleInfo = (
  isBalloonPaymentAvailable: boolean,
  isEligibleForAfg: boolean,
  loanVariables: any,
  modalId: string,
  dealSourceData: IDealSourceData | undefined = undefined,
  selectedLenderRouteOneId?: string | null,
) => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    if (isBalloonPaymentAvailable && isEligibleForAfg && loanVariables?.vin) {
      const params = {
        vin: loanVariables?.vin,
        ...extractDealSourceParams(dealSourceData, selectedLenderRouteOneId),
      };
      const vehicleData = {
        make: loanVariables?.make,
        model: loanVariables?.model,
        trim: loanVariables?.trim,
      };

      dispatch(getBalloonVehicleInfoThunk({ params, vehicleData, modalId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isBalloonPaymentAvailable,
    isEligibleForAfg,
    loanVariables?.vin,
    dealSourceData,
    selectedLenderRouteOneId,
    dispatch,
  ]);
};
